// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/date-picker/style/index.less
// module id = 1778
// module chunks = 1